import { createListFilters, IOption } from '../../../../../components'

export type FormulariosFilters = {
  /** Nome do formulário (busca parcial). */
  formulario: string
  /** Instituição — obrigatória para o Admin, que só lista formulários de uma instituição. */
  empresa?: IOption<number>
  status?: IOption<boolean>
}

export const { ListFiltersProvider, useListFilters } = createListFilters<FormulariosFilters>({
  formulario: '',
  empresa: undefined,
  status: undefined,
})
